angular.module('mtic.components.dashboards.teacher_general')
.directive('teacherDocuments', function ($http, $log, EventManager, userAccount, api,  DATA_HOST, language, $sce) {
  return {
    templateUrl: 'template.html',
    scope: {},
    link: function (scope, element) {

      var eventManager = new EventManager('teacherDocuments', scope);

      scope.getTranslation = function(id){
        return language.get(id);
      }

      scope.cards = {

        c3: {
          title: 'EF: Cycle 3',
          docs: [
            {
              title: 'mtic_c3_m1',
              pdf: 'https://vretta.app.box.com/s/nud57mnlt0226wcoc3sva38m335wtg4u'
              //docx: 'https://firebasestorage.googleapis.com/v0/b/mathematicmaker.appspot.com/o/item_authoring%2F20171010-Cycle%203%20-%20Modul%201%20-%20Textaufgaben%20-%20Didaktisches%20Leitblatt.docx?alt=media&token=29ec1a16-3beb-4de0-af67-eb8f8a10e94a'
            },
            {
              title: 'mtic_c3_m2',
              pdf: 'https://vretta.app.box.com/s/4v5qw7zv7yxmz5w5h70ipjia7wyh4nfe'
              //docx: 'https://firebasestorage.googleapis.com/v0/b/mathematicmaker.appspot.com/o/mtic2%2Fteacher%2Fstatic_assets%2FCycle%203%20-%20Modul%202%20-%20MathleTIC%20-%20Handreichungen.docx?alt=media&token=b9321d86-461d-4227-bd6e-652aaee53b06'
            },
            {
              title: 'mtic_c3_m3',
              pdf: 'https://vretta.app.box.com/s/8pdmn3napm806vjh4uluui8lusgnsmu5'
              //docx: 'https://firebasestorage.googleapis.com/v0/b/mathematicmaker.appspot.com/o/item_authoring%2F20171010-Cycle%203%20-%20Modul%201%20-%20Textaufgaben%20-%20Didaktisches%20Leitblatt.docx?alt=media&token=29ec1a16-3beb-4de0-af67-eb8f8a10e94a'
            },
            {
              title: 'mtic_c3_m4',
              pdf: 'https://vretta.app.box.com/s/8ls53se0o5yjoc82n5fwhofh26enlhij'
            }
          ]
        },

        c4: {
          title: 'EF: Cycle 4',
          docs: [
            {
              title: 'c4_m1',
              pdf: 'https://vretta.box.com/s/mm626zbrw3l7jv8tqqwmxdkj2aduogeb',
              // docx: 'https://firebasestorage.googleapis.com/v0/b/mathematicmaker.appspot.com/o/item_authoring%2F20171010-Module%201%20MathemaTIC%20-%20Fiche%20Didactique.docx?alt=media&token=2fe52dd9-d6b8-45ad-a216-a9c9a51d30e2'
            },
            {
              title: 'c4_m2',
              pdf: 'https://vretta.box.com/s/n9gdr2z2hnagp2z3iuql0tipzptryn1e',
              // docx: 'https://firebasestorage.googleapis.com/v0/b/mathematicmaker.appspot.com/o/item_authoring%2F20171010-Module%202%20MathemaTIC%20-%20Fiche%20Didactique.docx?alt=media&token=3139b3b7-3248-4543-9f28-c3b6b6129a1d'
            },
            {
              title: 'c4_m3',
              pdf: 'https://vretta.box.com/s/kkckqapguexas8ajjrze8a14qaqae0w7',
              // docx: 'https://firebasestorage.googleapis.com/v0/b/mathematicmaker.appspot.com/o/item_authoring%2F20171010-Module%203%20MathemaTIC%20-%20Fiche%20Didactique.docx?alt=media&token=22ce5bc8-204c-4089-b6c5-eecc510805ec'
            },
            {
              title: 'c4_m4',
              pdf: 'https://vretta.box.com/s/aayct3fjmze226sonlvkqpa4fl15x0sn',
              // docx: 'https://firebasestorage.googleapis.com/v0/b/mathematicmaker.appspot.com/o/item_authoring%2F20171010-Module%204%20MathemaTIC%20-%20Fiche%20Didactique.docx?alt=media&token=c7e8c193-5ba3-42e4-9df0-12e5fc55dc3d'
            },
            {
              title: 'c4_m5',
              pdf: 'https://vretta.box.com/s/iaacv82n5yeii9e9fx4gni7h40826biy',
              // docx: 'https://firebasestorage.googleapis.com/v0/b/mathematicmaker.appspot.com/o/item_authoring%2F20171010-Module%205%20MathemaTIC%20-%20Fiche%20Didactique.docx?alt=media&token=831d1c8c-ad8e-47a1-96d6-7898c045287f'
            },
            {
              title: 'c4_m6',
              pdf: 'https://vretta.box.com/s/owdnbz3vqwdl84tna4enfn9wojsby222',
              // docx: 'https://firebasestorage.googleapis.com/v0/b/mathematicmaker.appspot.com/o/item_authoring%2F20171010-Module%206%20MathemaTIC%20-%20Fiche%20Didactique.docx?alt=media&token=5a8a850d-8f9d-4249-99cf-d43dbb6548c2'
            },
            {
              title: 'mtic_c3_m2',
              pdf: 'https://vretta.box.com/s/271pqfn1clgcdccdwxv2idjs9zr7jdgr',
              // docx: 'https://firebasestorage.googleapis.com/v0/b/mathematicmaker.appspot.com/o/item_authoring%2F20171010-Module%206%20MathemaTIC%20-%20Fiche%20Didactique.docx?alt=media&token=5a8a850d-8f9d-4249-99cf-d43dbb6548c2'
            }
          ]
        },

        letterToTeachers: {
          title: '27702',
          singleDocs: [
            {
              title: '27702',
              doc: 'https://firebasestorage.googleapis.com/v0/b/mathematicmaker.appspot.com/o/item_authoring%2F20171010_lettre-enseignant.pdf?alt=media&token=8b4ada52-e008-4e19-94fd-74521ab774d3',
              titleAppend: ''
            },
          ]
        },

        letterToParents: {
          title: '27703',
          singleDocs: [
            {
              title: '27703',
              doc: 'https://firebasestorage.googleapis.com/v0/b/mathematicmaker.appspot.com/o/item_authoring%2F20171010_lettre-parents_all.pdf?alt=media&token=1b9bfe5c-9aee-4078-9c88-9d51a8f1c5a4',
              titleAppend: ' - all'
            },
            {
              title: '27703',
              doc: 'https://firebasestorage.googleapis.com/v0/b/mathematicmaker.appspot.com/o/item_authoring%2F20171010_lettre-parents_fr.pdf?alt=media&token=98dcf2b8-9414-4707-b269-cb12b61e76e1',
              titleAppend: ' - fr'
            },
            {
              title: '27703',
              doc: 'https://firebasestorage.googleapis.com/v0/b/mathematicmaker.appspot.com/o/item_authoring%2F20171010_lettre-parents_lux.pdf?alt=media&token=bb5c5cea-09ad-4c98-83d0-1276a565354c',
              titleAppend: ' - lux'
            },
          ],
        },

        // The following files are in firebase. Location: /mtic2/teacher/static_assets/
        instructionManuals: {
          title: '27700',
          singleDocs: [
            {
              title: '27700',
              doc: 'https://firebasestorage.googleapis.com/v0/b/mathematicmaker.appspot.com/o/mtic2%2Fteacher%2Fstatic_assets%2FMathemaTIC_lu%20Instruction%20Manual_LU_FR.pdf?alt=media&token=7d6363c7-0bbc-4d89-bdb4-f8a2f0ca0ce6',
              titleAppend: ' - fr'
            },
            {
              title: '27700',
              doc: 'https://firebasestorage.googleapis.com/v0/b/mathematicmaker.appspot.com/o/mtic2%2Fteacher%2Fstatic_assets%2FMathemaTIC_lu%20Instruction%20Manual_LU_%20EN.pdf?alt=media&token=426f2d4f-87f7-44bc-9bee-e02eb428c1e8',
              titleAppend: ' - en'
            },
          ],
        },

        chapters: {
          title: 'docs_chapters_title',
          docs: [
            {
              title: 'ES MathemaTIC Lessonplan - Angles et construction géométriques',
              pdf: 'https://vretta.box.com/s/1tked0xcj9ygdbn3n58u43qqd9ois7aa',
            },
            {
              title: 'ES MathemaTIC Lessonplan - Racines carrées et Pythagore',
              pdf: 'https://vretta.box.com/s/vlin4wnqmwsendmwx9hhnhckekrezql5',
            },
            {
              title: 'ES MathemaTIC Lessonplan - Transformations du plan',
              pdf: 'https://vretta.box.com/s/98tjxkkc321wfxmmshleibqn2ewi49di',
            },
            {
              title: 'ES MathemaTIC Lessonplan - Statistiques',
              pdf: 'https://vretta.box.com/s/a6fmj7lteoq0sxx77j0vjepztdyv2ne6',
            },
          ],
        },
        dataprotections: {
              title: ' ',
              docs: [
                {
                  title: 'dataprotectionen',
                  pdf: 'https://vrettamedia.s3.amazonaws.com/MTIC/FAQs%26Docs/MathemaTIC-Data_Protection%26Privacy_Policy-EN.pdf',
                },
                {
                  title: 'dataprotectionfr',
                  pdf:  'https://vrettamedia.s3.amazonaws.com/MTIC/FAQs%26Docs/MathemaTIC-Data_Protection%26Privacy_Policy-FR.pdf',
                },
                {
                  title: 'dataprotectionde',
                  pdf: 'https://vrettamedia.s3.amazonaws.com/MTIC/FAQs%26Docs/MathemaTIC-Data_Protection%26Privacy_Policy-DE.pdf',
                },
                {
                  title: 'dataprotectionpt',
                  pdf: 'https://vrettamedia.s3.amazonaws.com/MTIC/FAQs%26Docs/MathemaTIC-Data_Protection%26Privacy_Policy-PT.pdf',
                },
              ]
            }



      }
    }
  }
});
